import React from "react";
import { withPersonalInfo } from "@/utils/withPersonalInfo";
import dynamic from "next/dynamic";
import { message } from "antd";

message.config({
  maxCount: 1,
});

const MobileWorkbench = dynamic(
  () => import("@/pageComponents/mobileWorkbench"),
  {
    ssr: false,
  }
);

const WebWorkbench = dynamic(() => import("@/pageComponents/webWorkbench"), {
  ssr: false,
});

interface IProps {
  isMobile: boolean;
  isPersonal: boolean;
}

const Workbench: React.FC<IProps> = (props) => {
  const { isMobile, isPersonal } = props;

  return isMobile ? (
    <MobileWorkbench />
  ) : (
    <WebWorkbench isPersonal={isPersonal} />
  );
};

export const getServerSideProps = withPersonalInfo<Omit<IProps, "isPersonal">>(
  async (ctx) => {
    // 是否是移动端
    const userAgent = ctx.req.headers["user-agent"];
    const isMobile =
      /Mobile|webOS|BlackBerry|IEMobile|MeeGo|mini|Fennec|Android|iP(ad|od|hone)/i.test(
        userAgent || ""
      );
    return {
      props: {
        isMobile,
      },
    };
  }
);

export default Workbench;
